import Alpine from "alpinejs";

export default () => ({
    contactName: '',
    contactEmail: '',
    contactSubject: '',
    contactMessage: '',
    errors: {},
    csrfToken: '',
    myAccountContactFormInit() {
        this.csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    },
    async submitContactForm(e) {
         this.errors = {};
         const form = e.target.closest('form');
        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }

        const subjectLabel = this.$refs.subjects.querySelector('option:checked').textContent;

        const payload = {
            name: this.contactName,
            email: this.contactEmail,
            subject: subjectLabel,
            message: this.contactMessage,
        };

        const response = await fetch('/account/contact-us-form/', {
            method: 'POST',
            headers: {
                'X-CSRFToken': this.csrfToken,
            },
            body: JSON.stringify(payload),
        })
        if (!response.ok) {
            const errorData = await response.json();
            this.errors = errorData;
            return;
        }
        if (response.ok) {
            this.contactName = '';
            this.contactEmail = '';
            this.contactSubject = '';
            this.contactMessage = '';
            alert("Your message has been sent successfully!");
        }
    },
});